module.exports = __webpack_public_path__ + "img/jurrasic.526d6954.png";